/**
 * VulnerabilitiesTab Component
 *
 * Wrapper component for displaying asset vulnerabilities in the AssetDrawer.
 * Renders the Vulnerabilities table with predefined filters for the specific asset.
 */

import { Vulnerabilities } from '@/sections/vulnerabilities';

enum TableName {
  VULNERABILITIES = 'assetDrawerVulnerabilities',
}

interface VulnerabilitiesTabProps {
  /** The asset key to filter vulnerabilities by */
  assetKey: string;
}

/**
 * VulnerabilitiesTab displays vulnerabilities associated with a specific asset
 *
 * @param assetKey - The unique identifier for the asset
 */
export function VulnerabilitiesTab({ assetKey }: VulnerabilitiesTabProps) {
  return (
    <div className="size-full">
      <Vulnerabilities
        name={TableName.VULNERABILITIES}
        parentFilters={{ assetKey, advancedFilters: {} }}
        hideTitle
        inDrawer={true}
        drawerFilters={['status', 'severity', 'origin']}
      />
    </div>
  );
}
